import { Button } from "antd";
import * as React from "react";
import { defineMessages, useIntl } from "react-intl";

interface IProps {
    onConfirm: () => void;
    onBack: () => void;
    disabled?: boolean;
}

const MESSAGES = defineMessages({
    confirm: {
        id: "confirmation_modal_footer.confirm",
        defaultMessage: "Bevestig stop van cleaning"
    },
    back: {
        id: "confirmation_modal_footer.back",
        defaultMessage: "Keer terug naar cleaning"
    }
});

export const ConfirmationModalFooter = (props: IProps) => {
    const intl = useIntl();

    return (
        <div className="text-middle">
            <Button onClick={props.onBack}>
                {intl.formatMessage(MESSAGES.back)}
            </Button>
            <Button className="margin-half-left" type="primary" onClick={props.onConfirm} disabled={props.disabled}>
                {intl.formatMessage(MESSAGES.confirm)}
            </Button>
        </div>
    );
};
